// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bulletin-container[data-v-5e414d9f] {\n  max-height: 600px;\n  overflow-y: auto;\n}\n.file-item[data-v-5e414d9f] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin: 2px 0;\n}\n.file-item .el-link[data-v-5e414d9f] {\n  margin-right: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
